import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    filteredById: {},
    archivedById: {},
    loading: false,
    byPerma: {}
});

export default (state = getInitialState(), action) => {
    let newById;
    let newArchivedById;
    let newByPerma;
    let reduced;
    switch (action.type) {
        case ACTIONS.GET_MANY_COLLECTIONS_START: {
            return {
                ...state,
                loading: true
            };
        }
        case ACTIONS.GET_RECOMMENDED_AND_ASSIGNED_COLLECTIONS: {
            newById = { ...state.byId };
            newByPerma = { ...state.byPerma };
            const { collections } = action.payload;

            const mapCollections = (collection) => {
                const collectionDetails = { ...newById[collection._id], ...collection };
                newById[collection._id] = collectionDetails;
                newByPerma[collection.permalink] = collection;

                return {
                    _id: collectionDetails._id,
                    recommendationCount: collectionDetails.recommendedCount,
                    isRecommended: collectionDetails.isRecommended,
                    isAssigned: collectionDetails.isAssigned,
                    isRecommendedByTeamLead: collectionDetails.isRecommendedByTeamLead,
                    recommendationInfo: collectionDetails.recommendationInfo,
                    dateRecommended: collectionDetails.dateRecommended ?? null
                };
            };

            const assignedIds = collections.filter(({ isAssigned }) => isAssigned).map(mapCollections);
            const recommendedIds = collections
                .filter(({ isAssigned, isRecommended }) => isRecommended && !isAssigned)
                .map(mapCollections);

            return {
                ...state,
                byId: newById,
                loading: false,
                byPerma: newByPerma,
                recommendedIds,
                assignedIds
            };
        }

        case ACTIONS.GET_MANY_COLLECTIONS: {
            newById = { ...state.byId };
            newByPerma = { ...state.byPerma };
            const { collections } = action.payload;
            collections.forEach((collection) => {
                newById[collection._id] = collection;
                newByPerma[collection.permalink] = collection;
            });

            return {
                ...state,
                byId: newById,
                loading: false,
                byPerma: newByPerma
            };
        }

        case ACTIONS.GET_COLLECTION:
        case ACTIONS.PUT_COLLECTION_SUCCESS:
        case ACTIONS.POST_COLLECTION_SUCCESS: {
            const { collection } = action.payload;
            newById = {
                ...state.byId,
                [collection._id]: collection
            };
            newByPerma = {
                ...state.byPerma,
                [collection.permalink]: collection
            };
            return {
                ...state,
                byId: newById,
                byPerma: newByPerma,
                loading: false,
                currentId: collection._id
            };
        }

        case ACTIONS.GET_FILTERED_COLLECTIONS: {
            const { collections } = action.payload;
            reduced = {};
            newById = {
                ...state.byId
            };
            newByPerma = {
                ...state.byPerma
            };
            collections.forEach((collection) => {
                newById[collection._id] = collection;
                newByPerma[collection.permalink] = collection;
                reduced[collection._id] = collection;
            });

            return {
                ...state,
                byId: newById,
                byPerma: newByPerma,
                loading: false,
                filteredById: reduced
            };
        }

        case ACTIONS.PUT_ARCHIVED_COLLECTION_SUCCESS: {
            const { collection } = action.payload;
            newById = {
                ...state.byId
            };

            newArchivedById = {
                ...state.archivedById,
                [collection._id]: collection
            };

            const newFilteredById = {
                ...state.filteredById
            };

            if (collection._id in newById) {
                delete newById[collection._id];
            }

            if (collection._id in newFilteredById) {
                delete newFilteredById[collection._id];
            }

            return {
                ...state,
                byId: newById,
                loading: false,
                archivedById: newArchivedById,
                filteredById: newFilteredById
            };
        }

        case ACTIONS.PUT_UNARCHIVED_COLLECTION_SUCCESS: {
            const { collection } = action.payload;
            newById = {
                ...state.byId,
                [collection._id]: collection
            };

            newArchivedById = {
                ...state.archivedById
            };

            const newFilteredById = {
                ...state.filteredById,
                [collection._id]: collection
            };

            if (collection._id in newArchivedById) {
                delete newArchivedById[collection._id];
            }

            return {
                ...state,
                byId: newById,
                loading: false,
                archivedById: newArchivedById,
                filteredById: newFilteredById
            };
        }

        case ACTIONS.GET_MANY_ARCHIVED_COLLECTIONS: {
            const { collections } = action.payload;

            newArchivedById = {
                ...state.archivedById
            };

            collections.forEach((collection) => {
                newArchivedById[collection._id] = collection;
            });

            return {
                ...state,
                archivedById: newArchivedById
            };
        }

        case ACTIONS.CLEAR_SEARCHED_COLLECTIONS: {
            return {
                ...state,
                loading: false,
                filteredById: {}
            };
        }

        case ACTIONS.GET_FURTHER_LEARNING_COLLECTIONS_START: {
            return {
                ...state,
                loading: true
            };
        }

        case ACTIONS.GET_FURTHER_LEARNING_COLLECTIONS: {
            const { furtherLearningCollections } = action.payload;
            return {
                ...state,
                loading: false,
                furtherLearningCollections
            }
        }

        default:
            return state;
    }
};
